<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
        <ClarionDateControl
          class="input-text-size"
          v-model="editItem.startDateOnCloud"
          :label="`Start Date On Cloud`"
          :isIsoDate="true"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size ">General Payment Types:</h3>
        </v-col>
      </v-row>
      <v-row>
       <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            class="input-text-size"
            v-model="editItem.skipAutoCreatedBankDepositAndCheck"
            label="Skip auto-created bank deposit and check entries"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            class="input-text-size"
            v-model="editItem.autoCreateTaxRefundPayments"
            label="Auto Create Payments Entries for Tax Refunds"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            class="input-text-size"
            v-model="editItem.autoCreateCheckReversalPayments"
            label="Auto Create Payments Entries for Check Reversals"
          ></v-checkbox>
        </v-col>
     </v-row>
      <v-row>
        <v-col cols="3">
        <v-select
          class="input-text-size"
          label="Bank Account for Cleared Warrants"
          :items="bank"
          item-text="bankAltKey"
          item-value="_id"
          v-model="editItem.bankAccountForClearedWarrants"
        ></v-select>
      </v-col>
      <v-col cols="3">
        <v-select
          class="input-text-size"
          label="Bank Account for Cash/Check Deposit"
          :items="bank"
          item-text="bankAltKey"
          item-value="_id"
          v-model="editItem.bankAccountForCashCheckDeposit"
        ></v-select>
      </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
        <v-select
          class="input-text-size"
          label="Default Bank for Treasurer Checks"
          :items="bankList"
          item-text="bankAltKey"
          item-value="_id"
          v-model="editItem.treasurerCheckDefaultBank"
        ></v-select>
      </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size ">Default Bank Deposits</h3>
        <h4 class="input-text-size ">Tax</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
        <v-select
          class="input-text-size"
          label="Cash Deposit Bank"
          :items="bankList"
          item-text="bankAltKey"
          item-value="_id"
          v-model="editItem.cashDepositBank"
        ></v-select>
      </v-col>
      <v-col cols="3">
        <v-select
          class="input-text-size"
          label="Check Deposit Bank"
          :items="bankList"
          item-text="bankAltKey"
          item-value="_id"
          v-model="editItem.checkDepositBank"
        ></v-select>
      </v-col>
      <v-col cols="3">
        <v-select
          class="input-text-size"
          label="Credit Card Deposit Bank"
          :items="bankList"
          item-text="bankAltKey"
          item-value="_id"
          v-model="editItem.creditCardDepositBank"
        ></v-select>
      </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
        <v-select
          class="input-text-size"
          label="EFT Deposit Bank"
          :items="bankList"
          item-text="bankAltKey"
          item-value="_id"
          v-model="editItem.eftDepositBank"
        ></v-select>
      </v-col>
      <v-col cols="3">
        <v-select
          class="input-text-size"
          label="e-Check Deposit Bank"
          :items="bankList"
          item-text="bankAltKey"
          item-value="_id"
          v-model="editItem.eCheckDepositBank"
        ></v-select>
      </v-col>
      <v-col cols="3">
        <v-select
          class="input-text-size"
          label="Other Deposit Bank"
          :items="bankList"
          item-text="bankAltKey"
          item-value="_id"
          v-model="editItem.otherDepositBank"
        ></v-select>
      </v-col>
      </v-row>
     <v-row>
       <v-col
          cols="3"
        >
          <v-checkbox
            class="input-text-size"
            v-model="editItem.pageBreakSaiMonthlyReport"
            label="Page Breaks on SA&I report"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="3"
        >
          <v-checkbox
            class="input-text-size"
            v-model="editItem.useRateToCalculateInterest"
            label="Use Rate To Calculate Interest"
          ></v-checkbox>
        </v-col>
        <v-col cols="2">
        <v-select
          class="input-text-size"
          label="Override Source"
          :items="sources"
          item-text="sourceDesc"
          item-value="sourceSubSourceNumber"
          v-model="editItem.overrideSource"
        ></v-select>
      </v-col>
      <v-col
          cols="1"></v-col>
        <v-col
          cols="3"
        >
          <v-checkbox
            class="input-text-size"
            v-model="editItem.printGLHideDescription"
            label="Hide descriptions on GL Report"
          ></v-checkbox>
        </v-col>
     </v-row>
     <v-row>
      <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            class="input-text-size"
            v-model="editItem.collateralCashBal"
            label="Collateralize 110% of cash balance"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="9"
          md="4"
        >
         <v-checkbox
          class="input-text-size"
          v-model="editItem.usedRemarks"
          label="Use Remarks For Gl Daily Description"
        ></v-checkbox>
         </v-col>
         <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            class="input-text-size"
            v-model="editItem.appLedgerTransfer"
            label="Give option to create App Ledger Transfer "
          ></v-checkbox>
        </v-col>
        <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            class="input-text-size"
            v-model="editItem.fullDescPrint"
            label="Print full description on GL report with detail "
          ></v-checkbox>
        </v-col>
        <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            class="input-text-size"
            v-model="editItem.cloudTaxSystem"
            label="Cloud Tax System"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="9"
          md="4"
        >
        <v-checkbox
            class="input-text-size"
            v-model="editItem.autoRenumber"
            label="Don't auto-renumber 0000 funds"
          ></v-checkbox>
        </v-col>
         <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            class="input-text-size"
            v-model="editItem.hideMicrLineOnTreasurerChecks"
            label="Hide MICR line on Treasurer Checks"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            class="input-text-size"
            v-model="editItem.restrictTreasurerChecksToGlAdmins"
            label="Treasurer Checks access for GL Admins only"
          ></v-checkbox>
        </v-col>
     </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          color="primary"
          @click="update"
        >
          Save
        </v-btn>
      </v-card-actions>

    </v-card-text>
  </v-card>
</template>

<script>
import {
  mapActions, mapGetters, mapState, mapMutations,
} from 'vuex';
import ClarionDateControl from '../common/ClarionDateControl.vue';
import { toFiscalYear } from '../../util/shared/tmc-global';

const bankCrudKey = 'sharedBank';
const sourceCrudKey = 'sharedSource';

export default {
  components: {
    ClarionDateControl,
  },
  computed: {
    ...mapState({
      glConfig: (state) => state.SystemConfig.glSettingItem || {},
    }),
    ...mapGetters('base/crud', [
      'items',
    ]),
    ...mapGetters(['todaysDate']),
    editItem: {
      get() {
        return this.glConfig;
      },
      set(value) {
        this.setSetiingItem({ item: [value], scope: 'glConfig' });
      },
    },
    bank() {
      const bankObjs = this.items(bankCrudKey) || [];
      const updatedBankObjs = [];
      for (let index = 0; index < bankObjs.length; index += 1) {
        const element = bankObjs[index];
        if (element.altKeyBase !== '') {
          const currObj = {
            ...element,
            bankAltKey: ` ${element.altKeyBase || ''} - ${element.bankName}`,
          };
          updatedBankObjs.push(currObj);
        }
      }
      return [{ _id: null, bankAltKey: '', bankName: '' }, ...updatedBankObjs];
    },
    bankList() {
      const bankObjs = this.items(bankCrudKey) || [];
      const updatedBankObjs = bankObjs.map((b) => ({
        ...b,
        bankAltKey: ` ${b.altKeyBase || ''} - ${b.bankName}`,
      }));
      return [{ _id: null, bankAltKey: '', bankName: '' }, ...updatedBankObjs];
    },
    sources() {
      const sourceObjs = this.items(sourceCrudKey) || [];
      const updatedSourceObj = sourceObjs.map((s) => {
        const firstPartDesc = `${s.sourceSubSourceNumber} ${s.sourceDescription || ''}`;
        const secondPartDesc = s.subSourceDescription;
        return {
          ...s,
          sourceDesc: secondPartDesc == null || '' ? `${s.sourceSubSourceNumber} ${s.sourceDescription}` : `${firstPartDesc} - ${secondPartDesc}`,
        };
      });
      return [{ _id: null, sourceSubSourceNumber: '', sourceDesc: '' }, ...updatedSourceObj];
    },
  },
  created() {
    this.loadConfig({ requiredScope: 'glConfig' });
    this.loadBanks({
      criteria: {},
      baseCrudKey: bankCrudKey,
    });
    this.loadCmnSource({
      criteria: {
        fiscalYear: toFiscalYear(new Date(this.todaysDate)),
        isSkipMiscellaneousTransaction: false,
        sortBy: [
          {
            column: 'sourceSubSourceNumber',
            direction: 'asc',
          },
        ],
      },
      baseCrudKey: sourceCrudKey,
    });
  },
  methods: {
    ...mapMutations('SystemConfig', [
      'setSettingItem',
    ]),
    ...mapActions('SystemConfig', ['updateConfig', 'loadConfig',
    ]),
    ...mapActions('shared/bank', [
      'loadBanks',
    ]),
    ...mapActions('shared/source', [
      'loadCmnSource',
    ]),
    buildGlConfigItem() {
      const settingItem = this.editItem;
      /* When you will update any new field in the GL setting,
        you need to add the field here. */
      return {
        id: settingItem.id,
        startDateOnCloud: settingItem.startDateOnCloud,
        skipAutoCreatedBankDepositAndCheck: settingItem.skipAutoCreatedBankDepositAndCheck,
        autoCreateTaxRefundPayments: settingItem.autoCreateTaxRefundPayments,
        autoCreateCheckReversalPayments: settingItem.autoCreateCheckReversalPayments,
        bankAccountForClearedWarrants: settingItem.bankAccountForClearedWarrants,
        bankAccountForCashCheckDeposit: settingItem.bankAccountForCashCheckDeposit,
        cashDepositBank: settingItem.cashDepositBank,
        checkDepositBank: settingItem.checkDepositBank,
        creditCardDepositBank: settingItem.creditCardDepositBank,
        eftDepositBank: settingItem.eftDepositBank,
        eCheckDepositBank: settingItem.eCheckDepositBank,
        otherDepositBank: settingItem.otherDepositBank,
        treasurerCheckDefaultBank: settingItem.treasurerCheckDefaultBank,
        pageBreakSaiMonthlyReport: settingItem.pageBreakSaiMonthlyReport,
        useRateToCalculateInterest: settingItem.useRateToCalculateInterest,
        overrideSource: settingItem.overrideSource,
        printGLHideDescription: settingItem.printGLHideDescription,
        collateralCashBal: settingItem.collateralCashBal,
        usedRemarks: settingItem.usedRemarks,
        appLedgerTransfer: settingItem.appLedgerTransfer,
        fullDescPrint: settingItem.fullDescPrint,
        cloudTaxSystem: settingItem.cloudTaxSystem,
        autoRenumber: settingItem.autoRenumber,
        hideMicrLineOnTreasurerChecks: settingItem.hideMicrLineOnTreasurerChecks,
        restrictTreasurerChecksToGlAdmins: settingItem.restrictTreasurerChecksToGlAdmins,
      };
    },
    update() {
      if (window.confirm('Are you sure want to update this configuration?')) {
        const payload = { calledScope: 'glConfig', item: this.buildGlConfigItem() };
        this.updateConfig(payload);
      }
    },
  },
};
</script>
